export default "__VITE_ASSET__GzbKFXNu__"